<template>


<div class="login-page" v-loading.body="loading.login">


    <el-row :gutter="20">
      <el-col :span="10" :offset="7">

        <div class="wrapper-page">

            <div class="login-splash-logo">
                <img v-bind:src="config.logo" class="login-logo" />
            </div>



                <el-card class="box-card" v-loading="loading">

                    <el-alert
                    v-if="error"
                    title="An error occured"
                    type="error"
                    @close="clearError()"
                    >
                    <p class="el-alert__description">{{error}}</p>
                    </el-alert>

                    <el-form>
                        <el-form-item label="Username" prop="username">
                          <el-input
                            size="large"
                            placeholder="Enter your username"
                            v-model="credentials.login">
                          </el-input>
                        </el-form-item>

                        <el-form-item label="Password" prop="password">
                          <el-input
                            size="large"
                            placeholder="Enter your password"
                            type="password"
                            v-model="credentials.password"
                            @keyup="keyMonitor()">
                          </el-input>
                        </el-form-item>

                        <el-form-item>

                            <el-button @click="login('loginForm')" :loading="false" type="primary">Login</el-button>
                            
                        </el-form-item>


                    </el-form>

                    <div class="login-card-footer">
                        <el-button type="text" @click="dialogVisibleForgottenPassword = true">Forgotten your password?</el-button>
                    </div>

                </el-card>

        </div>

      </el-col>
    </el-row>

<el-dialog
  title="Forgotten Password"
  :visible.sync="dialogVisibleForgottenPassword"
  size="tiny">
  <span>Enter your registered email below to receive your password reset details</span>

    <el-form>
        <el-form-item label="Email" prop="email">
            <el-input
            size="large"
            placeholder="Enter your email"
            v-model="credentials.email">
            </el-input>
        </el-form-item>


    </el-form>


  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibleForgottenPassword = false, credentials.email ==''">Cancel</el-button>
    <el-button @click="sendMail()" :loading="false" type="primary" :disabled="credentials.email ==''">Send Reset</el-button>
  </span>
</el-dialog>

</div>

</template>

<style scoped>

.text-center {
    text-align: center;
}

div.login-page {
    color: #fff;
    background: #312783; /* Old Browsers */
    background: -webkit-linear-gradient(bottom left,#312783,#6e689b); /*Safari 5.1-6*/
    background: -o-linear-gradient(bottom left,#312783,#6e689b); /*Opera 11.1-12*/
    background: -moz-linear-gradient(bottom left,#312783,#6e689b); /*Fx 3.6-15*/
    background: linear-gradient(bottom left, #312783, #6e689b); /*Standard*/	height: 100%;
	padding: 0;
	position: absolute;
	left: 0;
	right: 0;
    margin-top: -20px;
}


.login-splash-logo {
    text-align: center;
    padding: 2em 0 2em 0;
    margin-top:2.5em;
}

.login-pane {
	padding: 30px;
    background-color: rgba(255,255,255,1);
    -moz-box-shadow: 1px 1px 20px rgba(0,0,0,0.3);
    -webkit-box-shadow: 1px 1px 20px rgba(0,0,0,0.3);
    box-shadow: 1px 1px 20px rgba(0,0,0,0.3);
    border-radius: 4px;
}

.login-splash-logo img {
    image-rendering: crisp;
}

.login-logo {
    max-width:250px;
    height: auto;
    image-rendering: crisp;
}

.corporate-branding {
    text-align: center;
}


.app-credits {
	color: #fff;
	font-size: 12px;
	font-weight: 500;
	margin-top: 30px;
	margin-bottom: 30px;
	text-align: center;
}

.login-card-footer {
    padding:15px 0 15px 0;
    text-align:center;
}

</style>


<script>
    

import auth from '@/components/auth/AuthCheck.js';
import Config from '@/store/Config.js';
// import VueRecaptcha from 'vue-recaptcha';

export default {

  // components: { VueRecaptcha },

  data(){
    return {
        config: Config.config,
        loading: false,
        credentials: {
            login: '',
            password: '',
            email: '',
        },
        error: '',
        loginForm: {},
        // sitekey: '6Lcl8TcUAAAAAOoMbcqwV4gm1XYT9WCZt45YqHdr',
        capture_verified: true,
        dialogVisibleForgottenPassword: false,
    }
  },





  methods:{

    onSubmit: function () {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function (response) {
      console.log('Verify: ' + response);
      this.capture_verified = true;
    },
    onExpired: function () {
      console.log('Expired')
      this.capture_verified = false;
      this.resetRecaptcha();
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },

    login(formName) {
        if (this.capture_verified === true) {
            // this.loading = true;
            auth.login(this, this.credentials, '/')
            this.resetRecaptcha();
        } else {
            console.log('You must check the re-capture');
            // this.loading = false;
        }

    },

    sendMail(){
        console.log(this.credentials.email);
        auth.forgotPassword(this, this.credentials);
        this.dialogVisibleForgottenPassword = false;
    },

    keyMonitor: function(event) {
        console.log('Key monitor function');
        console.log(event.key);
        if(event.key == "Enter")
        {
            auth.login(this, this.credentials, '/');
        }
    },

    clearError: function() {
        console.log('Clear error message function');
        const me = this;
        me.error = '';
    }
  }
}




</script>




// WEBPACK FOOTER //
// src/pages/login/LoginPage.vue